import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Icon, Input, Button, Menu, Alert } from 'antd'
import { Redirect } from 'react-router-dom'
import authManager from './services/auth'
import css from './Login.css'

export default class LoginForm extends Component {
  state = {
    email: null,
    password: null,
    error: null,
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const user = JSON.stringify({
      user: {
        email: this.state.email,
        password: this.state.password,
      },
    })
    authManager.authenticate(user)
      .then(() => {
        this.setState({
          error: null,
        })
      })
      .catch((err) => {
        this.setState({
          error: err.body.error_message || "There was an error signing in"
        })
      })
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    const {
      email, password, error,
    } = this.state

    if (authManager.isAuthenticated) {
      return (
        <Redirect to="/dashboard" />
      )
    }
    return (
      <div className={css.container}>
        <Menu
          theme="dark"
          selectable={false}
          mode="horizontal"
          className={css.header}
        >
          <Menu.Item >
              Admin Portal
          </Menu.Item>
        </Menu>
        <Form
          onSubmit={this.handleSubmit}
          className={css.form}
        >
          {error && <Alert type="error" message="Error" description={error} /> }
          <Form.Item
            label="Email"
            colon={false}
            className={css.formItem}
          >
            <Input
              prefix={<Icon type="user" />}
              name="email"
              onChange={this.handleInputChange}
            />
          </Form.Item>
          <Form.Item
            label="Password"
            colon={false}
          >
            <Input
              prefix={<Icon type="lock" />}
              type="password"
              name="password"
              onChange={this.handleInputChange}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              disabled={!(email && password)}
              className={css.button}
            >
                Log in
            </Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Login.js